var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-checkbox-group",class:{'is-row': _vm.row},attrs:{"aria-label":"checkbox-group","data-qa":"checkbox-group","role":"group"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }